import {Tooltip, Alert} from "bootstrap";
import {utils} from "@shop/frontend/web/js/utils";
import {googleAnalytics} from "@shop/frontend/web/js/components/googleAnalytics";
import {saveUtmToCookie} from "@shop/frontend/web/js/utils/utm";
import {hamburger} from "@shop/frontend/web/js/components/hamburger";
import api from "@shop/frontend/web/js/api";
import {QuantityCounter} from "@shop/frontend/web/js/components/QuantityCounter";
import {Modal} from "@shop/frontend/web/js/components/Modal";
import {translator} from "@shop/frontend/web/js/services/TranslatorService";
import formField from "@shop/frontend/widgets/FormField/scripts/form-field";
import {updateEmailAddress} from "@shop/frontend/web/js/components/updateEmailAddress";
import {formValidation} from "@frontend/src/js/components/formValidation";
import {changeCheckboxes} from "@shop/frontend/web/js/components/changeCheckboxes";
import {orderHistoryCardView} from "./views/OrderHistoryCardView";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { DatePickerComponent } from '@frontend/src/js/components/DatePickerComponent';

export class App {
	constructor() {
		/**
		 * Будет включать в себя компонент для работы с датой рождения
		 * @module DatePickerComponent
		 */
		this.datePicker_birthday = null;
	}

	init(params = {}) {
		$(".dropdown").ariaDropdown();
		$.each($("[data-bs-toggle=tooltip]"), (i, tooltip) => new Tooltip(tooltip, {}));
		$.each($(".alert"), (i, alert) => {
			const bpAlert = new Alert(alert);
			$(alert)
				.find(".btn-close")
				.on("click", () => bpAlert.close());
		});

		utils.addVoidForLinks($("a"));

		hamburger("js-hamburger", "js-menu");

		if (window.gaEnabled && window.ga) googleAnalytics();
		saveUtmToCookie();
		this.initFastRegistration();
		this.initToggleActiveClass();
		this.initCheckUserByEmailInput();
		this.initQuantityCounter();
		this.initTicketReturn();
		this.initRegister();
		
		this.modal = new Modal({ className: "i-modal_alert" });
		this.refundModal = new Modal({ className: "i-modal_refund", id: "some-unique-id-3" });
		this.refundSuccessModal = new Modal({
			className: "i-modal_refund-success",
			id: "some-unique-id-36",
		});
		if ($("#registerModal").length) this.registerModal = new Modal().use("registerModal");
		if ($("#fastRegisterModal").length)
			this.fastRegisterModal = new Modal().use("fastRegisterModal");

		if (params.CartService) CartService.getCount();

		this.setUpListeners();
		this.setUpModalListeners();
		this.setUpFormListeners();
		if ($("#js-access").length > 0) this.setUpAccessListeners();
		formField();
		changeCheckboxes();
		updateEmailAddress();
		formValidation();

		orderHistoryCardView.initSetActiveCard();
		$(window).on("resize", orderHistoryCardView.initSetActiveCard);
		moment.locale(`${document.documentElement.lang}`);
	}

	setUpListeners() {
		$(document).on("click", "#js-hide-play-info", e => {
			const element = $(e.currentTarget);
			const parent = element.parents(".play-info");
			parent.remove();
		});

		$(document).on("click", ".js-event-more", e => {
			const element = $(e.currentTarget);
			const parent = element.parents(".js-text-parent");
			element.toggleClass("active");
			parent.find(".js-event-text").slideToggle();
		});

		$(".js-toggle-long-text").on("click", e => {
			$(e.currentTarget).toggleClass("active").prev().toggleClass("short");
			const text = $(e.currentTarget).find("span");

			text.text(translator.t("main", "Show description"));

			if ($(e.currentTarget).hasClass("active"))
				text.text(translator.t("main", "Hide description"));
		});

		$(document).ready(function () {
			const SHOW_TEXT = translator.t("main", "More details");
			const HIDE_TEXT = translator.t("main", "Hide");
		
			$(document).on("click", ".change-day__btn", function (e) {
				e.stopPropagation();
		
				const $list = $(".change-day__list");
				const $desc = $(".long-text__text.long-text__mobile");
				const $descBtn = $(".js-toggle-long-text-mobile");
		
				const isAlreadyOpen = $(this).hasClass("active");
		
				$(".change-day__btn").removeClass("active");
				$(".change-day__list").removeClass("active");
				$descBtn.removeClass("active").find("span").text(SHOW_TEXT);
				$desc.removeClass("active");
		
				if (!isAlreadyOpen) {
					$(this).addClass("active");
					$list.addClass("active");
				}
			});
		
			$(document).on("click", ".js-toggle-long-text-mobile", function (e) {
				e.stopPropagation();
		
				const $list = $(".change-day__list");
				const $desc = $(".long-text__text.long-text__mobile");
				const $dateBtn = $(".change-day__btn");
		
				const isAlreadyOpen = $(this).hasClass("active");
		
				$(".js-toggle-long-text-mobile").removeClass("active").find("span").text(SHOW_TEXT);
				$(".long-text__text.long-text__mobile").removeClass("active");
				$dateBtn.removeClass("active");
				$list.removeClass("active");
		
				if (!isAlreadyOpen) {
					$(this).addClass("active").find("span").text(HIDE_TEXT);
					$desc.addClass("active");
				}
			});
		});

		$(document).ready(function () {
			const SHOW_TEXT = translator.t("main", "Show");
			const HIDE_TEXT = translator.t("main", "Hide");
	
			$(document).on("click", ".package-event__mobile-btn", function (e) {
					e.stopPropagation();
					
					const $content = $(this).next(".package-event__content");
					const $buttonText = $(this).find("span");
					const $icon = $(this).find(".icon");
	
					if ($content.is(":visible")) {
							$content.slideUp();
							$buttonText.text(SHOW_TEXT);
							$icon.removeClass("active");
					} else {
							$content.slideDown();
							$buttonText.text(HIDE_TEXT);
							$icon.addClass("active");
					}
			});
		});

		$(document).on("mouseout", ".js-hover-out", e => {
			const element = $(e.currentTarget);
			element.blur();
		});

		$(document).on("input", ".js-without-symbols", e => {
			const element = e.target;
			element.value = element.value.replace(/[^a-zа-яё0-9\s]/gi, "");
		});

		$(document).on("input", ".js-max-value", e => {
			const element = e.target;
			const maxValue = element.getAttribute("max");
			if (element.value.length > maxValue) {
				element.value = element.value.substring(0, element.value.length - 1);
			}
		});

		$(document).on("click", ".js-hide-additional-info", e => {
			const element = $(e.currentTarget);
			const parent = element.parents(".additional-info");
			$(parent).slideUp(300);
		});
	}

	setUpFormListeners() {
		$(".enter form").on("submit", e => {
			const form = $(e.currentTarget);
			form.find("button[type='submit']").addClass("disabled");
		});

		$(".enter__input ").on("input", () => {
			$(".enter form button[type='submit']").removeClass("disabled");
		});

		$(".checkbox__input").on("keydown", e => {
			const element = $(e.currentTarget);

			if (e.code === "Enter" || e.code === "NumpadEnter") {
				element.toggleClass("checked");

				if ($(element).hasClass("checked")) {
					$(element).prop("checked", true);
				} else {
					$(element).prop("checked", false);
				}
			}
		});

		$(document).on("click", ".js-enter-visible-password", e => {
			const element = $(e.currentTarget);
			const input = element.parents(".enter__block").find(".enter__input");
			element.toggleClass("active");

			if (input.attr("type") === "text") {
				input.attr("type", "password");
				element.attr(
					"aria-label",
					"Show password as plain text. " +
						"Warning: this will display your password on the screen."
				);
			} else {
				input.attr("type", "text");
				element.attr("aria-label", "Hide password.");
			}
		});

		$.each($(".form-group input"), (i, item) => {
			const element = $(item);
			if (element.val()) {
				element.next().addClass("inactive");
			}
		});

		$(".form-group input").on("input", e => {
			const element = $(e.currentTarget);
			element.next().addClass("inactive");
			if (!element.val()) {
				element.next().removeClass("inactive");
			}
		});

		$(".form-group input").on("click", e => {
			const element = $(e.currentTarget);
			element.next().addClass("inactive");
		});

		$(".form-group input").on("blur", e => {
			const element = $(e.currentTarget);
			if (!element.val()) {
				element.next().removeClass("inactive");
			}
		});

		$('.checkbox_register input[type="checkbox"]').on("change", e => {
			const $element = $(e.currentTarget);
			const value = Number($element.val());
			if (value === 1) {
				$element.prev().val(0);
				$element.val(0);
			} else {
				$element.prev().val(1);
				$element.val(1);
				$(".js-fast-btn").removeClass("disabled");
			}
		});
	}

	setUpModalListeners() {
		$(".js-get-access-modal").on("click", e => {
			if (this.registerModal) this.registerModal.hide(e);
			const initial = $(e.currentTarget).data("initial");
			$(".access-request__link").hide();
			$(`.access-request__link[data-initial="${initial}"]`).show();
		});

		$(document).on("click", ".js-get-modal", e => {
			const $element = $(e.currentTarget);
			const modal = $element.data("target");

			$(".modal").modal("hide");
			if (this.fastRegisterModal) this.fastRegisterModal.hide();
			
			$(modal).modal("show");
		});

		$(".modal").on("shown.bs.modal", function (e) {
			disableBodyScroll(this);
			$("body").addClass("modal-open");
		});

		$(".modal").on("hide.bs.modal", function (e) {
			enableBodyScroll(this);
		});
	}

	setUpAccessListeners() {
		$(".js-sphere-item").on("click", e => {
			const element = $(e.currentTarget);
			const index = element.index() + 1;
			const selectedText = element.text();
			$("#requestadmin-activity_sphere")[0][index].selected = true;
			$("#js-dropdown-sphere").ariaDropdown("slideUp");
			$("#js-dropdown-sphere .dropdown__btn").find("span").text(selectedText);
		});

		$(".js-access-radio").on("change", e => {
			const element = $(e.currentTarget);
			const type = element.val();
			$(".js-access-content").hide();
			$(`.js-access-content[data-type='${type}']`).show();
		});

		$("#js-access-hide").on("click", () => {
			$("#js-access").slideUp();
			utils.setCookie("accessHide", true, { path: "/", "max-age": "36000000" });
		});

		$("#js-close-access").on("click", () => $("#js-access").slideUp());
	}

	initQuantityCounter() {
		$.each(
			$(".js-quantity-counter"),
			(i, quantityCounter) => new QuantityCounter(quantityCounter)
		);
	}

	initTicketReturn() {
		if (!$(".js-ticket-return").length > 0) return false;

		$(".js-ticket-return").on("click", e => {
			const $element = $(e.currentTarget);
			const orderId = $element.data("order");
			const eventId = $element.data("event");
			const fragment = document.importNode($("#js-template-refund")[0].content, true);
			const returnConfirm = $(fragment).find("#js-return-confirm");
			returnConfirm.data("order", orderId);
			returnConfirm.data("event", eventId);
			this.refundModal.show(fragment);
		});

		$(document).on("click", "#js-return-confirm", e => {
			const $element = $(e.currentTarget);
			const orderId = $element.data("order");
			const eventId = $element.data("event");

			api.refund
				.refund({ orderId, eventId })
				.then(res => {
					if (!res.success) throw new Error(res.message);

					const fragment = document.importNode(
						$("#js-template-refund-success")[0].content,
						true
					);

					this.refundModal.hide();
					this.refundSuccessModal.show(fragment);

					const order = $(`.js-order[data-id="${orderId}"]`);
					const returnBtn = order.find(`.js-ticket-return[data-event="${eventId}"]`);
					returnBtn.siblings(".js-was-refund").show();
					returnBtn.remove();

					if (order.find(".js-ticket-return").length === 0) {
						order.find(".history__buttons").remove();
					}
				})
				.catch(err => {
					console.log(err);
					this.modal.show(
						`
						${translator.t("main", "An error occurred!")}
						<p>${err.message || "Неизвестная ошибка с сервера!"}</p>
						`
					);
				});
		});
	}

	initCheckUserByEmailInput() {
		$(".js-input-email-fast").on("change", e => {
			const element = $(e.currentTarget);
			const email = element.val();
			api.user.check({ email }).then(user => {
				const form = element.parents("form");
				const second = form.find(".js-fast-second")[0];
				const first = form.find(".js-fast-first")[0];
				const phone = form.find(".js-fast-phone")[0];
				second.value = user.second;
				first.value = user.first;
				phone.value = user.phone;
			});
		});
	}

	initFastRegistration() {
		$(document).on("click", ".js-get-fast-registration", e => {
			const el = $(e.currentTarget);
			e.preventDefault();
			if (this.fastRegisterModal) this.fastRegisterModal.show();
			const sum = el.parents(".js-order").find(".js-sum").text();
			$(".js-sum-fast").text(sum);
			let action = $("#fast-registration-controller").attr("action");
			const eventId = $(el.parents(".js-order").find(".js-order-event")[0]).data("event-id");
			const resultID = action?.match(/event_id=\d*/);
			action = action?.replace(resultID, `event_id=${eventId}`);
			$("#fast-registration-controller").attr("action", action);
		});
	}

	initToggleActiveClass() {
		$(document).on("click", ".js-toggle-active", e => {
			const target = $(e.currentTarget).data("toggle-target");

			$(e.currentTarget).toggleClass("active");

			if (target) return $(target).toggleClass("active");
		});
	}

	initRegister() {
		this.datePicker_birthday = new DatePickerComponent($('.js-datepicker'), { opens: 'right' });
	}
}
